(() => {
  const SCOPE_SELECTORS = [
    '.section-resource-list',      // product-list (home)
    '.main-collection-grid',       // collections
    '.product-grid',               // grilles
    '.resource-list'               // carousels Pitch
  ];

  function inScope(el) {
    return SCOPE_SELECTORS.some((s) => el.closest(s));
  }

  function moveBrand(cardContent) {
    if (!inScope(cardContent)) return;

    const brand = cardContent.querySelector(':scope > .inura-card-brand');
    if (!brand) return;

    // cible "titre" (Pitch varie selon le renderer)
    const title =
      cardContent.querySelector('product-title') ||
      cardContent.querySelector('.product-title') ||
      cardContent.querySelector('.view-product-title') ||
      cardContent.querySelector('.title-text') ||
      null;

    // Si on ne trouve pas le titre, on ne fait rien.
    if (!title) return;

    // On place la marque juste avant le titre (et donc sous la galerie)
    const titleContainer = title.closest('product-title, .product-title, .view-product-title') || title;
    titleContainer.parentNode.insertBefore(brand, titleContainer);
  }

  function run() {
    document.querySelectorAll('.product-card__content').forEach(moveBrand);
  }

  // initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // support sections dynamiques / infinite scroll
  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();